import type { MbcAdminCheck } from "@nlc/shared-types";
import type { UseQueryResult } from "@tanstack/react-query";

import { useQuery } from "@tanstack/react-query";

import { mbcAdminKeys } from "@/hooks/queryKeys";

import { listChecks } from "../api";

export function useChecks(): UseQueryResult<MbcAdminCheck[], Error> {
  return useQuery({
    queryFn: listChecks,
    queryKey: mbcAdminKeys.checks(),
  });
}
